import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contextsKeys } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import {
  type SignInResult,
  type SwitchContextRequest,
  postAuthContextSwitch,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SignInResult) => void;
  onError?: (error: unknown) => void;
};

/**
 * Switches the active IdentityUser (role/membership context) for the current Identity.
 * Returns a fresh JWT — caller must persist it and refresh the Redux user state.
 */
export const useSwitchContextMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: SwitchContextRequest) => postAuthContextSwitch(data),
    ),
    onSuccess: (result: SignInResult) => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      queryClient.invalidateQueries({ queryKey: contextsKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
